"use client"

import { create } from "zustand"
import { persist } from "zustand/middleware"

import { EN, ID, type Key } from "./i18n-messages"

export type Locale = "EN" | "ID"

const messages: Record<Locale, Record<Key, string>> = { EN, ID }

interface LocaleState {
  locale: Locale
  setLocale: (locale: Locale) => void
}

export const useLocaleStore = create<LocaleState>()(
  persist((set) => ({ locale: "EN", setLocale: (locale) => set({ locale }) }), {
    name: "psc-locale",
  })
)

/** Non-hook t() for code outside React (the API client). */
export function t(key: Key) {
  return messages[useLocaleStore.getState().locale][key] ?? EN[key]
}

/** Returns t(key) for the active locale; falls back to EN if a key is missing. */
export function useT() {
  const locale = useLocaleStore((s) => s.locale)
  return (key: Key) => messages[locale][key] ?? EN[key]
}
